import type { SelectionPartition } from "./partitionSelections";

/**
 * Replay the link's ordered segment codes into recipient-space. A usable segment
 * resolves to existingCode (if present, i.e., ALREADY_HAVE fingerprint match) or
 * its code verbatim (OWNED/ACCESSIBLE). An adopted segment (confirmed, in
 * adoptedMapping) resolves to its mapped result. Blocked or unresolved segments
 * (no adoptable mapping, not in usable set) are dropped. Order is preserved, and
 * the first occurrence of any code wins (deduped by original code).
 */
export function resolveLinkSegmentSelection(input: {
  linkSegmentCodes: string[];
  partition: SelectionPartition;
  adoptedMapping: Record<string, string>;
}): string[] {
  const { linkSegmentCodes, partition, adoptedMapping } = input;
  const seen = new Set<string>();

  // Build a map from segment code -> resolved recipient-space code
  // from the usable segments (OWNED/ALREADY_HAVE/ACCESSIBLE).
  const usableMap = new Map<string, string>();
  for (const seg of partition.usable.segments) {
    usableMap.set(seg.code, seg.existingCode ?? seg.code);
  }

  const resolved: string[] = [];
  for (const code of linkSegmentCodes) {
    if (!code || seen.has(code)) continue;
    seen.add(code);

    // Check usable first
    const usableResult = usableMap.get(code);
    if (usableResult) {
      resolved.push(usableResult);
      continue;
    }

    // Check adopted
    const adoptedResult = adoptedMapping[code];
    if (adoptedResult) {
      resolved.push(adoptedResult);
      continue;
    }

    // Drop (blocked or no verdict)
  }

  return resolved;
}
